// pass a variable, the prop options as it would be defined in vue, and optionally the store module, which will become a module named for convenience in the store.

export default function(variableName, propOptions, storeModuleName) {
  const pascalCaseName = variableName[0].toUpperCase() + variableName.slice(1)
  let mixin = { props: {}, computed: {}, methods: {} }
  mixin.props[variableName] = propOptions
  // Returns: a computed variable prepended with '_' to your var name. This is the computed value that will get its value from the store, or the local data value specified by varibleName.
  mixin.computed[`_${variableName}`] = {
    get() {
      try {
        return storeModuleName
          ? this.$store['state'][storeModuleName][variableName]
          : this.$store.state[variableName]
      } catch {
        return this[variableName]
      }
    },
    // emit an update event and value and call method to set value in store.
    set(value) {
      this.$emit(`update:${variableName}`, value)
      try {
        this[`set${pascalCaseName}`](value)
      } catch {
        // throw away
      }
    },
  }
  mixin.methods[`set${pascalCaseName}`] = function(value) {
    this.$store.dispatch(
      `${storeModuleName ? storeModuleName + '/' : ''}set${pascalCaseName}`,
      value
    )
  }
  return mixin
}
